var nav = {
    pageStatus: {
        home: true,
        category: false,
        shop: false,
        kefu: false,
        isKefuOpened: false, //客服窗口打开过
        isKefuAutoOpened: false,
        autoOpenTimer: null, //自动打开客服窗口计时器
    },

    changeNav: function (e, cate, urlPara) {
        if (cate === 'category') {
            this.closeAll();
            if (!this.pageStatus.category) {
                this.pageStatus.category = true;
                // $('.page-home').css('display', 'none');
                $('.nav-' + cate).addClass('hover ani-jump');
                window.location.href = '/catalog/';
            } else {
                this.pageStatus.category = false;
            }
        }
        if (cate === 'shop'){
            this.closeAll();
            if (!this.pageStatus.shop) {
                this.pageStatus.shop = true;
                if(window.cateData.pageModule != 'premier'){
                    window.location.href = eshop_host;
                }
            } else {
                this.pageStatus.shop = false;
            }
        }
        if (cate === 'form') {
            var linksourcemodule = '';
            if(window.cateData.pageModule === 'industry'){
                linksourcemodule =  window.cateData.pageIndustryName;
            }else{
                if(window.cateData.userRecodeOption.category2){
                    linksourcemodule =  window.cateData.userRecodeOption.category2;
                }else if(window.cateData.userRecodeOption.category1) {
                    linksourcemodule = window.cateData.userRecodeOption.category1;
                }else{
                    linksourcemodule =  window.cateData.userRecodeOption.module;
                }
            }
            if (window.cateData.pageModuleName) {
                linksourcemodule = window.cateData.pageModuleName;
            }

            //处理url参数
            var addUrl = '';
            if(urlPara){
                for(var key in urlPara){
                    addUrl += '&' + key + '=' + encodeURIComponent(urlPara[key]);
                }
            }
            //采购单链接
            gio('track', 'click_further_Intentions', {'consultEntrancePage': document.title, 'consultEntrancePageURL': document.URL});
        }
        if (cate === 'kefu') {
            if (this.isSelf(e, '.nav-' + cate)) {
                this.closeAll();
            } else {
                this.closeAll();
                $('.nav-' + cate).addClass('hover ani-jump');
                $('.kefu-list-box').removeClass('hide');
                this.setKefuOpenStatus('initiative');
            }
        }
        if (cate === 'home') {
            window.location.href = solution_host + '/recommend/';
        }
        if (cate === 'closeIT'){
            $('.bottomIT').addClass('hide');
        }
        if (cate === 'toIT'){
            window.location.href = "https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fintegral%2Findex&query=pos%3Dmodule-item-5"
        }
    },

    //关闭所有
    closeAll: function () {
        $('.nav-item').removeClass('hover ani-jump');
        this.setDef();
        $('.page').css('display', 'none');
        $('.page-home').css('display', 'block');
        $('.kefu-list-box').addClass('hide');
        this.setKefuOpenStatus('passive');
    },

    //是否是本身
    isSelf: function (e, type) {
        return $(type).hasClass('hover');
    },

    //监测滚动条滚动
    monitorScroll: function () {
        var _this = this;
        var timer = null;
        window.onscroll = function () {
            //取消客服
            $('.kefu-list-box').addClass('hide');
            $('.nav-kefu').removeClass('hover ani-jump');
            _this.setKefuOpenStatus('passive');
            // IT订阅
            clearTimeout(timer);
            $('.bottomIT').addClass('bottomIT-option');
            timer = setInterval(function () {
                $('.bottomIT').removeClass('bottomIT-option');
            },500);
        };
    },

    //客服弹出窗触摸效果
    kefuHover: function () {
        $('.kefu-list-box>ul>li').on('touchstart', function () {
            $(this).addClass('kefuhover');
        });

        $('.kefu-list-box>ul>li').on('touchend', function () {
            $(this).removeClass('kefuhover');
        });
    },

    //设置默认选中
    setDef: function () {
        //根据当前页面模块判断哪个默认选中
        switch (window.cateData.pageModule) {
            case 'industry':
                $('.nav-category').addClass('hover');
                break;
            case 'tank':
                $('.nav-category').addClass('hover');
                break;
            case 'program':
                $('.nav-category').addClass('hover');
                break;
            case 'filelist':
                $('.nav-category').addClass('hover');
                break;
            case 'user':
                $('.nav-me').addClass('hover');
                break;
            case 'catalog':
                $('.nav-category').addClass('hover');
                break;
            case 'light-reading':
                $('.nav-category').addClass('hover');
                break;
        }
        //根据当前页面模块中文名称判断哪个默认选中
        switch (window.cateData.pageModuleName) {
            case '资料中心-专业版':
                $('.nav-home').addClass('hover');
                break;
        }
    },

    //40秒后自动弹出
    setAtuoOpen: function () {
        var _this = this;
        if (window.cateData.pageModule === 'tank' || window.cateData.pageModule === 'program' || window.cateData.pageModule === 'activity' || window.cateData.pageModule === 'product' || window.cateData.pageModule === 'media') {
            var isCookieKefuOpened = $.cookie('isKefuOpened');
            if (!isCookieKefuOpened) { //如果打开过则24小时内不再自动打开
                _this.autoOpenTimer = setTimeout(function () {
                    //打开弹窗
                    $('.nav-kefu').addClass('hover ani-jump');
                    $('.kefu-list-box').removeClass('hide');

                    //设置打开状态
                    _this.pageStatus.kefu = true;

                }, window.cateData.kefuOpenTime * 1000);
            }
        }
    },

    //设置客服显示状态
    setKefuOpenStatus: function (status) {
        if (status === 'initiative') { //主动点击
            if (!this.pageStatus.kefu) { //设置客服打开状态
                this.pageStatus.kefu = true;
            } else {
                this.pageStatus.isKefuOpened = true;
                this.pageStatus.kefu = false;
            }
        } else { //被动触发
            if (this.pageStatus.kefu) {
                this.pageStatus.isKefuOpened = true;
                this.pageStatus.kefu = false;
            }
        }
        this.setKefuCookie();

    },

    //设置24小时不再打开
    setKefuCookie: function () {
        var _this = this;
        //如果窗口打开过则设置一个24小时的cookie不再触发自动打开 并取消当前页面的40秒自动打开计时器
        if (_this.pageStatus.isKefuOpened) {
            //清除计时器
            clearTimeout(_this.autoOpenTimer);

            //设置cookie
            var isCookieKefuOpened = $.cookie('isKefuOpened');
            if(!isCookieKefuOpened){ //如果cookie不存在再设置
                var expire = new Date();
                expire.setTime(expire.getTime()+ (24 * 60 * 60 * 1000));
                $.cookie('isKefuOpened', 'true', {expires: expire, path: '/'});
            }
        }
    },

    //设置topbar返回按钮
    setTopBarBack: function () {
        var goHomeEl = document.querySelector('.go-home');
        var backLinkEl = document.querySelector('.back>a');
        if(!goHomeEl || !backLinkEl){
            return;
        }
        if(document.referrer === '' || document.referrer.indexOf(solution_m_host) === -1){
            goHomeEl.classList.remove('hide');

            //根据所在页面设置返回链接
            if(window.cateData.pageModule === 'user'){ //用户中心
                goHomeEl.textContent = '';
                backLinkEl.setAttribute('href', window.rootUrl + '/user/index.html');
            }else if(window.cateData.pageModule === 'author'){ //作者主页
                goHomeEl.textContent = '';
                backLinkEl.setAttribute('href', window.rootUrl + '/author/' + window.authorId);
            }else if(window.cateData.pageModule === 'shopDetailMiaoSha'){ //秒杀详情
                goHomeEl.textContent = '';
                backLinkEl.setAttribute('href', 'https://m.dellemc-solution.com/');
            }else{
                backLinkEl.setAttribute('href', eshop_host);
            }

        }else{
            goHomeEl.classList.add('hide');
            backLinkEl.setAttribute('href', 'javascript:history.back(-1)');
        }
        // alert(document.referrer);
        // alert(history.length);
    },

    init: function () {
        this.setDef();
        this.monitorScroll();
        this.kefuHover();
        // this.setAtuoOpen();
        this.setTopBarBack();
    }
};

nav.init();
